const state = {
  stateTagsList: [
    {
      title: '首页',
      name: '/welcome'
    }
  ]
}

const mutations = {
  selectTags(state, data) {
    let result = false
    for(let i = 0; i < state.stateTagsList.length; i++){
      if(state.stateTagsList[i].name == data.name){
        return result = true
      }
    }
    result == false ? state.stateTagsList.push({ title: data.title, name: data.name }) : ''
  },
  closeTags(state, data) {
    let result = state.stateTagsList.findIndex(item => item.name === data)
    state.stateTagsList.splice(result, 1)
  },
  setTags(state, data) {
    state.stateTagsList = [{ title: '首页', name: '/welcome' }]
  }
}

const actions = {
  selectTags({ commit }, data) {
    commit('selectTags', data)
  },
  closeTags({ commit }, data) {
    commit('closeTags', data)
  },
  setTags({ commit }, data) {
    commit('setTags', data)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}


// WEBPACK FOOTER //
// ./src/store/modules/tag.js